<template>
  <div class="emplayee">
    <div class="auto_1280">
      <div class="infor clearfix">
        <div class="fl">
          <div class="title">{{intro.title}}</div>
          <pre class="intro">{{intro.content}}</pre>
        </div>
        <div class="fr">
          <table cellpadding="0" cellspacing="0" style="border-collapse:collapse">
            <tr v-if="lan === 0">
              <td>年份</td>
              <td>志愿服务时长（小时）</td>
            </tr>
            <tr v-else-if="lan === 1">
              <td>Particular Year</td>
              <td>Volunteer service duration(Hour)</td>
            </tr>
            <tr v-for="( item, index ) in durationList" :key="index">
              <td>{{item.year}}</td>
              <td>{{item.hours}}</td>
            </tr>
          </table>
          <div class="subtit">{{intro.tag}}</div>
        </div>
      </div>
    </div>
    <div class="pic-show">
      <div class="auto_1280">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="( item, index ) in picList" :key="index">
              <div class="pic bg_cover" :style="'background-image: url(' + item.coverImg + ')'"></div>
              <div class="tit dot">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="bg"></div>
    </div>
    <div class="development">
      <div class="auto_1280">
        <div class="tit1" v-if="lan === 0">员工公益发展历程</div>
        <div class="tit1 en" v-else-if="lan === 1">Development process of employee public welfare</div>
        <ul class="ul">
          <li v-for="( item, index ) in durationList" :key="index">
            <div class="content">
              <div class="year dot">{{item.year}}</div>
              <div class="txt">{{item.content}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'EmployeeWelfare',
  data () {
    return {
      intro: {},
      durationList: [],
      picList: [],
      lan: this.$store.state.isEn,
      articleTypeId: 9
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
    this.initSwiper()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      this.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.durationList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, year: 'true', bLanguage: this.lan }, r => {
        r.data.forEach((item) => {
          self.durationList.push(item)
        })
      })
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, tag: 'true', bLanguage: this.lan }, r => {
        self.intro = r.data[0]
      })
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, bLanguage: this.lan }, r => {
        self.picList = r.data
        self.$nextTick(function () {
          self.initSwiper()
        })
      })
    },
    initSwiper () {
      /* eslint-disable no-new */
      new Swiper('.swiper-container', {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 40,
        loop: true,
        autoplay: 3000,
        speed: 1000,
        nextButton: '.pic-show .swiper-button-next',
        prevButton: '.pic-show .swiper-button-prev',
        breakpoints: {
          768: {
            slidesPerView: 2
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.emplayee .infor{padding: 5% 0;}
.emplayee .fl{float: left; width: 50%; padding-right: 12%; padding-top: 8%;}
.emplayee .fr{float: right; width: 50%;}
.emplayee .title{font-size: 40px; color: #e4007f;}
.emplayee .intro{line-height: 2; text-align: left; padding-top: 12%; font-family: "Microsoft YaHei";}
.emplayee table{width: 100%;}
.emplayee tr:first-child{background-color: #fff6fb;}
.emplayee td{line-height: 60px; height: 60px; width: 50%; text-align: center; border: 1px solid #f7f0f4; font-size: 16px; color: #333;}
.emplayee tr:first-child td{color: #e4007f; font-weight: lighter;}
.emplayee .subtit{color: #999; text-align: center; line-height: 40px;}

.emplayee .pic-show{position: relative; margin-bottom: 5%;}
.emplayee .pic{width: 100%; padding-top: 65%;}
.emplayee .swiper-slide{width: 33.3333%; margin: 2% 0 0 0;}
.emplayee .tit{text-align: center; font-weight: lighter; color: #333; line-height: 60px;}
.emplayee .swiper-button-prev,.emplayee .swiper-button-next{width: 50px; height: 50px; border-radius: 10px 0; border: 2px solid rgba(228,0,127,0.2);}
.emplayee .swiper-button-prev{background: url(../../assets/a_prev.png)no-repeat center; transition: all .3s; left: 5%; top: 40%;}
.emplayee .swiper-button-next{background: url(../../assets/a_next.png)no-repeat center; transition: all .3s; right: 5%; top: 40%;}
.emplayee .swiper-button-prev:hover{background: url(../../assets/a_prev_on.png)no-repeat center #e4007f;}
.emplayee .swiper-button-next:hover{background: url(../../assets/a_next_on.png)no-repeat center #e4007f;}
.emplayee .bg{width: 100%; padding-top: 7%; background-image: url(../../assets/dots.png); background-position: center; background-repeat: no-repeat;}

.emplayee .development{background-color: #fff5fb; padding: 5% 0;}
.emplayee .tit1{font-size: 36px; color: #333; text-align: center;}
.emplayee ul{background: url(../../assets/tree.png)no-repeat center top; margin-top: 3%; padding: 3% 0 8%; background-size: contain;}
.emplayee li{position: relative;}
.emplayee .content{border-radius: 30px 0; padding: 5% 6%; background-color: #fff;}
.emplayee li:nth-child(2n-1){margin-right: 50%; background: url(../../assets/branch-left.png)no-repeat right 90%; padding-right: 90px;}
.emplayee li:nth-child(2n){margin-left: 50%; background: url(../../assets/branch-right.png)no-repeat left 90%; padding-left: 90px;}
.emplayee .year{position: absolute; top: -25px; left: 6%; font-size: 36px; font-weight: bold; color: #e4007f;}
.emplayee .txt{font-weight: lighter; color: #222; line-height: 2;}
.emplayee li:nth-child(2n) .year{left: calc(6% + 90px);}
@media(max-width: 1280px){
  .emplayee .bg{background-image: url(../../assets/dots-1280.png); background-size: cover;}
  .emplayee .swiper-button-prev{background: url(../../assets/a_prev_on.png)no-repeat center #e4007f;}
  .emplayee .swiper-button-next{background: url(../../assets/a_next_on.png)no-repeat center #e4007f;}
}
@media(max-width: 768px){
  .emplayee .title{font-size: 38px;}
  .emplayee .tit1.en{font-size: 24px;}
  .emplayee .fl,
  .emplayee .fr{width: 100%; padding: 2% 0;}
  .emplayee .swiper-button-prev,.swiper-button-next{width: 40px; height: 40px;}
  .emplayee .swiper-slide{padding: 0 10px;}
  .emplayee .tit{font-size: 14px; line-height: 50px;}
}
@media(max-width: 640px){
  .emplayee .title{font-size: 30px;}
  .emplayee ul{background: none;}
  .emplayee li:nth-child(2n){margin-left: 5%; background: none; padding-left: 0;}
  .emplayee li:nth-child(2n-1){margin-right: 5%; background: none; padding-right: 0;}
  .emplayee li{margin: 7% 0;}
  .emplayee li:nth-child(2n) .year{left: 6%;}
  .emplayee .year{font-size: 24px; top: -15px;}
  .emplayee .tit1{font-size: 28px;}
}
</style>
